<template>
  <select class="ui dropdown" v-model="value">
    <option v-for="(option,index) in options" :value="option" >{{option.label||option.title||option}}</option>
  </select>
</template>

<script>
    export default {
      name: "select-element",
      props:{
        options:Array,
        initValue:null,
        resetValue:Boolean
      },
      // data:()=>{
      //   return {
      //     testValue:this.initValue
      //   }
      // },
      computed:{
        value:{
          get(){return this.initValue},
          set(newVal){this.$emit("input",newVal);}
        }
      },
      watch:{
        // value(newValue){
        //   this.$emit("input",newValue);
        //   if (this.resetValue) this.value=null;
        // }
      }
    }
</script>

<style scoped>

</style>
